import React, { useRef } from 'react'
import Button from '@mui/joy/Button'
import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined'

export const FilePickerButton = ({ onFileChange, accept = 'image/*' }) => {
    const fileRef = useRef(null)

    const handleFileClick = (e) => {
        fileRef.current.click()
    }

    return (
        <>
            <Button
                startDecorator={<CloudUploadOutlined />}
                onClick={handleFileClick}
                color="primary"
                variant="soft"
            >
                Upload File
            </Button>
            <input
                type="file"
                accept={accept}
                onChange={onFileChange}
                style={{ display: 'none' }}
                ref={fileRef}
            />
        </>
    )
}
